import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Badge, Box, Button, Container, FileUpload, Form, FormField, Link, Modal, Select, SpaceBetween, Table, Textarea, TruncatedText } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAttachment, mdiCardSearchOutline, mdiMagnify, mdiMessageOutline, mdiPaperclip } from '@mdi/js';
import { Icon } from '@mdi/react';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, downloadFile, fileToBase64, getCookie, getUrlVersion, getUser, isMobileDevice, setData, setLoading, setParameters } from '../../../../commons/functions';
import { btnIconForm, OptionDefinition } from '../../../../../resources/types';
import { format, parse } from 'date-fns';
import HorizontalRule from '../../../../../components/HorizontalRule';


type LogBookItem = {
    idComplaint: number;
    idUser: number;
    dateComplaint: string;
    timeComplaint: string;
    idComplaintCategory: number;
    idComplaintType: number;
    complaint: string;
    complaintCategory?: string;
    complaintType?: string;
    jsonImages: any[];
}
export const MembersEtcLogBookPage = () => {
    //const storeAdmin = useStoreAdmin();

    const { data, menu, parameters } = useGlobalState();

    const [showImageModal, setShowImageModal] = useState(false);
    const [imgIndex, setImgIndex] = useState(0);
    const [imgUrl, setImgurl] = useState("");

    const [complaints, setComplaints] = useState<LogBookItem[]>([]);
    const [complaintView, setComplaintView] = useState<LogBookItem | null>(null);
    const [complaint, setComplaint] = useState<LogBookItem | null>(null)
    const [showMore, setShowMore] = useState<boolean>(false);
    const [files, setFiles] = React.useState<File[]>([]);
    const [years, setYears] = useState<OptionDefinition[]>([]);

    const handleFileChange = async (files: File[]) => {
        if (!complaint) return;

        const base64Results = await Promise.all(files.map(fileToBase64));
        const resizedResults = await Promise.all(
            base64Results.map(async (result) => {
                const base64WithPrefix = result.base64.startsWith("data:")
                    ? result.base64
                    : `data:${result.file.type};base64,${result.base64}`;
                const resizedBase64 = await resizeBase64Image(base64WithPrefix, 800, 0.7);
                const cleanedBase64 = resizedBase64.replace(/^data:image\/\w+;base64,/, "");


                return {
                    idMaintenance: complaint?.idComplaint,
                    fileName: result.file.name,
                    fileContent: cleanedBase64,
                    fileSize: result.file.size
                };
            })
        );

        setComplaint((prev: LogBookItem | null) => {
            if (!prev) return prev;
            return {
                ...prev,
                // Use the spread operator on the entire new array to append all new files
                jsonImages: [...(prev?.jsonImages || []), ...resizedResults]
            };
        });
        //} catch (error) {
        //   console.error('Error reading files:', error);
        // Handle error state if necessary
        //}
    };

    const handleComplaintSave = async () => {
        //console.log("handleComplaintSave")
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/complaints/update',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify(complaint)
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb && dataWeb.code === 0) {
                handleGetComplaints();
                setComplaint(null);
                setFiles([]);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching users:', error);
        } finally {
        }
    };
    const handleYearsComplaints = async () => {
        //console.log("handleGetComplaints")
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/complaints/years',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify({})
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const dataWeb = await response.json();
            if (dataWeb && dataWeb.years) {

                setYears([
                    { value: "", label: "Seleccione" },
                    ...dataWeb.years.map((item: any) => ({
                        value: item.value,
                        label: item.label
                    }))
                ]);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleGetComplaints = async () => {
        //console.log("handleGetComplaints")
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/complaints/list',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify({
                    year: parameters.year,
                    orderBy: "dateComplaint",
                    order: "desc",
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const dataWeb = await response.json();
            if (dataWeb && dataWeb.complaints) {
                setComplaints(dataWeb.complaints);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        handleYearsComplaints();
    }, []);
    useEffect(() => {
    }, [complaint]);
    const complaintTypes = data.complaintTypes.map((category: any) => ({
        value: category.idComplaintType,
        label: category.complaintType
    }));
    const complaintCategories = data.complaintCategories.map((category: any) => ({
        value: category.idComplaintCategory,
        label: category.complaintCategory
    }));

    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const handleTakePhoto = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    // Handle photos taken from camera input
    const handleCameraChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = e.target.files ? Array.from(e.target.files) : [];
        if (selectedFiles.length > 0) {
            setFiles(prev => [...prev, ...selectedFiles].slice(0, 3)); // limit to 3
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<SpaceBetween direction="horizontal" size="xs">
                        {!complaint && (
                            <Button
                                disabled={(!years || years.length === 0) || parameters.year === ""}
                                onClick={() => {
                                    setComplaint((prev: any) => ({ ...prev, idComplaint: 0, idComplaintCategory: 0, idComplaintType: 0, complaint: '', jsonImages: [] }));
                                }}
                            >Agregar</Button>
                        )}
                        {complaint && (
                            <Button
                                onClick={() => {
                                    setComplaint(null)
                                }}
                            >Volver</Button>
                        )}
                        <Favorites />
                    </SpaceBetween>}>Libro de observaciones</Header>
                    {complaint && (
                        <Form
                            header={<Alert type="warning" header="Importante">
                                No utilize este módulo para reportar problemas del material de vuelo. Si desea reportar material de vuelo debe ser realizado desde las notas de mantenimiento.
                            </Alert>}
                            actions={
                                <Button onClick={() => handleComplaintSave()}

                                    variant='primary'
                                    disabled={complaint === null || complaint.complaint.trim() === '' || complaint.idComplaintCategory === 0 || complaint.idComplaintType === 0}
                                >Agregar</Button>
                            }>
                            <SpaceBetween size="s">
                                <SpaceBetween size="s" direction='horizontal'>
                                    <div style={{ minWidth: 200 }}>
                                        <FormField label="Categoría">
                                            <Select
                                                selectedOption={complaintCategories.find((opt: any) => opt.value === complaint.idComplaintCategory) || null}
                                                onChange={(event) => {
                                                    setComplaint((prev: any) => ({
                                                        ...prev,
                                                        idComplaintCategory: Number(event.detail.selectedOption?.value) || 0
                                                    }))
                                                }}
                                                options={complaintCategories}
                                            />
                                        </FormField>
                                    </div>
                                    <div style={{ minWidth: 200 }}>
                                        <FormField label="Tipo">
                                            <Select
                                                selectedOption={complaintTypes.find((opt: any) => opt.value === complaint.idComplaintType) || null}
                                                onChange={(event) => {
                                                    setComplaint((prev: any) => ({
                                                        ...prev,
                                                        idComplaintType: Number(event.detail.selectedOption?.value) || 0
                                                    }))
                                                }}
                                                options={complaintTypes}
                                            />
                                        </FormField>
                                    </div>
                                </SpaceBetween>
                                <FormField label="Observación">
                                    <Textarea
                                        rows={5}
                                        value={complaint.complaint}
                                        onChange={(detail) => {
                                            setComplaint((prev: any) => ({
                                                ...prev, complaint: detail.detail.value
                                            }))
                                        }}
                                    ></Textarea>
                                </FormField>

                                <FileUpload
                                    onChange={({ detail }) => {
                                        const newFiles = detail.value.slice(0, 3);
                                        setFiles(newFiles);
                                        handleFileChange(newFiles);
                                    }}
                                    accept="image/*"
                                    value={files}
                                    i18nStrings={{
                                        uploadButtonText: e =>
                                            "Seleccionar imagen",
                                        dropzoneText: e =>
                                            "Arrastre archivo para cargar",
                                        removeFileAriaLabel: e =>
                                            `Eliminar archivo ${e + 1}`,
                                        limitShowFewer: "Show fewer files",
                                        limitShowMore: "Show more files",
                                        errorIconAriaLabel: "Error",
                                        warningIconAriaLabel: "Warning"
                                    }}
                                    multiple
                                    showFileSize
                                    showFileThumbnail
                                    fileTokenAlignment="horizontal"
                                    tokenLimit={3}
                                />

                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept="image/*"
                                    capture="environment" // or "user" for front camera
                                    style={{ display: "none" }}
                                    onChange={handleCameraChange}
                                />
                                {isMobileDevice() && (
                                    <Button onClick={handleTakePhoto}>
                                        Tomar foto
                                    </Button>
                                )}
                            </SpaceBetween>
                        </Form>
                    )}
                    {!complaint && (

                        <Table
                            variant='embedded'
                            stickyHeader

                            filter={
                                <Box>
                                    <Box float="left">
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <FormField label="Filtro anual">
                                                <Select
                                                    loadingText="Cargando años..."
                                                    options={years}
                                                    selectedOption={years.find(y => y.value.toString() === parameters.year.toString()) || null}
                                                    onChange={({ detail }) => {
                                                        setParameters({
                                                            ...parameters,
                                                            year: Number(detail.selectedOption.value)
                                                        });
                                                    }}
                                                />
                                            </FormField>

                                            <FormField label="&nbsp;">
                                                <Button style={{ root: btnIconForm }}
                                                    disabled={parameters.year === "" || parameters.course === ""}
                                                    onClick={() => handleGetComplaints()}><Icon path={mdiMagnify} size={1} /></Button>
                                            </FormField>
                                        </SpaceBetween>
                                    </Box>

                                </Box>
                            }
                            columnDefinitions={[{
                                id: 'date',
                                header: 'Fecha',
                                width: 120,
                                cell: (item) => <FormField label={item.dateComplaint} description={item.timeComplaint} />
                                ,
                            },
                            {
                                id: 'category',
                                header: 'Categoría/Tipo',
                                cell: (item) => <FormField label={data.complaintCategories.find((c: any) => c.idComplaintCategory === item.idComplaintCategory)?.complaintCategory || ''}>
                                    {data.complaintTypes.find((t: any) => t.idComplaintType === item.idComplaintType)?.complaintType || ''}
                                </FormField>,
                            }, {
                                id: 'note',
                                header: 'Usuario/Nota',
                                cell: (item) => (
                                    <FormField label={getUser(item.idUser, data)?.displayName}
                                        info={
                                            <SpaceBetween direction="horizontal" size="xs">
                                                <Link onClick={() => {
                                                    setComplaintView(item)
                                                }}>
                                                    <Icon path={mdiCardSearchOutline} size={0.75} />
                                                </Link>
                                                {item.jsonImages && item.jsonImages.length > 0 && (
                                                    <SpaceBetween direction="horizontal" size="xs">
                                                        <Icon path={mdiPaperclip} size={0.75} /><small>{item.jsonImages.length}</small>
                                                    </SpaceBetween>
                                                )}

                                            </SpaceBetween>
                                        }
                                    >


                                        {item.complaint.length > 100 ? (
                                            <>{item.complaint.substring(0, 100)}...</>
                                        ) : (
                                            item.complaint
                                        )}

                                    </FormField>
                                ),
                            },
                            ]}
                            cellVerticalAlign="top"
                            items={complaints}
                            loadingText="Cargando..."

                        />
                    )}
                    <Modal size="medium" onDismiss={() => { setComplaintView(undefined); }} visible={!!complaintView}

                        footer={
                            <Box float="right">
                                <Button variant="link" onClick={() => { setComplaintView(undefined); }}>Cerrar</Button>
                            </Box>
                        }
                        header={<Header variant='h2'
                        >{`Observación de ${getUser(complaintView?.idUser || 0, data)?.displayName}`}</Header>}
                    >
                        <SpaceBetween direction="horizontal" size="s">
                            <FormField label="Emisión" constraintText={complaintView?.timeComplaint}>
                                {complaintView?.dateComplaint}
                            </FormField>

                            <FormField label="Tipo">
                                {complaintView?.complaintType}
                            </FormField>

                            <FormField label="Categoría">
                                {complaintView?.complaintCategory}
                            </FormField>

                        </SpaceBetween>


                        <FormField label="Observacion">
                            <Container >{complaintView?.complaint}</Container>
                        </FormField>
                        {complaintView?.jsonImages && complaintView?.jsonImages.length > 0 && (
                            <SpaceBetween direction="vertical" size="s">

                                <HorizontalRule />

                                <SpaceBetween direction="horizontal" size="s">

                                    {complaintView?.jsonImages.map((image: any, index: number) => (
                                        <img style={{ width: "auto", height: 120, float: "left", marginRight: 10, marginBottom: 10 }} key={index}
                                            src={`${image.url}`}


                                            onClick={() => {
                                                setImgIndex(index);
                                                setImgurl(image.url);
                                                setShowImageModal(true);
                                            }}
                                        />

                                    ))}
                                </SpaceBetween>
                            </SpaceBetween>

                        )}

                    </Modal>

                    <Modal header={
                        <Header actions={<Button variant="link"

                            onClick={async () => {
                                setLoading(true);
                                downloadFile(complaintView?.jsonImages?.[imgIndex]?.url || "", complaintView?.jsonImages?.[imgIndex]?.name || "unknown.jpg")
                                setLoading(false);
                            }}


                        >Descargar</Button>}>Detalle de imagen
                        </Header>
                    } visible={showImageModal} size="max" onDismiss={() => setShowImageModal(false)}>
                        <img
                            src={complaintView?.jsonImages?.[imgIndex]?.url || ""}
                            style={{
                                display: "block",         // remove inline spacing
                                maxWidth: "100%",         // never exceed modal width
                                maxHeight: "80vh",        // prevent overflow vertically
                                margin: "20px auto",      // center horizontally
                                height: "auto",           // keep aspect ratio
                                borderRadius: 5,
                                objectFit: "contain"      // ensures full image fits
                            }}
                            alt="Detalle"
                        />
                        {complaintView?.jsonImages && complaintView?.jsonImages.length > 1 && (
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <SpaceBetween direction="horizontal" size="l">
                                    {complaintView?.jsonImages?.map((image, index) => (
                                        <Button
                                            key={index}
                                            variant={index === imgIndex ? "primary" : "normal"}
                                            onClick={() => setImgIndex(index)}
                                        >
                                            {index + 1}
                                        </Button>
                                    ))}
                                </SpaceBetween>
                            </div>
                        )}
                    </Modal>
                </SpaceBetween >
            }
        />
    );
};

export const resizeBase64Image = (
    base64: string,
    maxSize: number,
    quality: number = 0.7
): Promise<string> => {
    return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => {
            const { width, height } = img;

            // Determine which side is larger
            const isWidthLarger = width >= height;

            // Compute proportional dimensions
            let targetWidth: number;
            let targetHeight: number;

            if (isWidthLarger) {
                const ratio = maxSize / width;
                targetWidth = maxSize;
                targetHeight = height * ratio;
            } else {
                const ratio = maxSize / height;
                targetHeight = maxSize;
                targetWidth = width * ratio;
            }

            const canvas = document.createElement("canvas");
            canvas.width = targetWidth;
            canvas.height = targetHeight;

            const ctx = canvas.getContext("2d");
            if (!ctx) return reject("Canvas not supported");

            ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

            resolve(canvas.toDataURL("image/jpeg", quality));
        };

        img.onerror = reject;
        img.src = base64;
    });
};

